import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getModifierOptionsFilteredData } from '../services/modifierOptionsCostServices';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        Name: ""
      });

      const handleFilterSpeedOfServices = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { Name } = filterCriteria;
    
          let filterProduct = true;
    
          if (Name) {
            filterProduct = item?.ModiferOptionNameEng?.toLowerCase().includes(Name.toLowerCase());
          }

          return (
            filterProduct
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getModifierOptionsFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.reports.analysis_reports.modifier_options_cost")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterSpeedOfServices}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.reports.reports_tables.name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.reports.reports_tables.name")}
                name="Name"
                value={filterCriteria.Name}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Name: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
};